export default {
  SET_GOOGLE_AUTH(state, payload) {
    state.googleAuth = payload;
  },
};
